<template>
  <!-- 新增文章弹层 -->
  <el-dialog :title="mode=='add'?'发布公告':'公告详情'" :visible.sync="visibleModel" @open="handleOpen"
             modal-append-to-body>
    <el-form label-position="left">
      <el-form-item label="公告标题" label-width="90px">
        <zt-input placeholder="请输入标题" v-model="formModel.title" maxlength="30"></zt-input>
        <p class="form-tips">不超过30个字</p>
      </el-form-item>
      <el-form-item label="公告内容" label-width="90px">
        <ZtEditor
          v-model="formModel.content"
          placeholder="请输入公告内容">
        </ZtEditor>
      </el-form-item>
      <el-form-item label="是否置顶" label-width="90px">
        <el-radio-group v-model="top">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <zt-button type="primary" v-if="mode=='edit'" @click="handleEdit" class="add-btn">修改</zt-button>
      <zt-button type="primary" v-else @click="handledAdd" size="medium" class="add-btn">发布</zt-button>
      <div class="clear"></div>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  admin_public_notice_add,
  admin_public_notice_edit,
  admin_public_notice_set_top,
  admin_public_notice_set_untop
} from '@/api/notice';
import ZtEditor from '@/components/ZtEditor/ZtEditor';

export default {
  name: 'NoticeEditDialog',
  components: {
    ZtEditor,
  },
  props: {
    visible: Boolean,
    mode: String, // add edit
    form: {
      type: Object,
      default() {
        return {}
      },
    },

  },
  computed: {
    visibleModel: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      formModel: {
        // 标题
        title: '',
        // 内容
        content: '',
      },
      top: 0,

    }
  },
  methods: {
    // 打开
    handleOpen() {
      Object.assign(this.$data, this.$options.data())
      if(this.mode == 'edit') {
        this.formModel = {...this.form}
        this.top = this.formModel.order_id === 1 ? 1 : 0
      }
    },
    // 设置置顶
    async setTop(status, id) {
      const setApi = status ? admin_public_notice_set_top : admin_public_notice_set_untop
      await setApi({id})
    },
    // 编辑
    async handleEdit() {
      if(!this.handleValid()) return
      const {data} = await admin_public_notice_edit({ ...this.formModel})
      if (data.error_code == 0) {
        this.$message.success('修改公告成功');
        this.visibleModel = false;
        await this.setTop(this.top, this.formModel.id)
        this.$emit('update')
      } else {
        this.$message.error(data.error_message);
      }
    },
    // 添加
    async handledAdd() {
      if(!this.handleValid()) return
      const {data} = await admin_public_notice_add({...this.formModel, top: this.top})
      if (data.error_code == 0) {
        this.$message.success('发布公告成功');
        this.visibleModel = false;
        this.$emit('update')
      } else {
        this.$message.error(data.error_message);
      }
    },
    handleValid() {
      if (this.formModel.title == '' || this.formModel.title == undefined) {
        this.$message.error('公告标题不能为空')
        return
      }
      if (this.formModel.content == '' || this.formModel.content == undefined) {
        this.$message.error('公告内容不能为空')
        return
      }
      return true
    },
  },

}
</script>

<style lang="scss" scoped>
.add-btn {
  width: 72px;
  float: right;
  margin-top: 22px;
}

.clear {
  clear: both;
  width: 0px;
  height: 0px;
}

.form-tips {
  margin-top: 7px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(141, 146, 153, 1);
  line-height: 17px;
}
</style>
